const CACHE_KEY = "barcode_cache_v1";

export function getCachedProduct(barcode: string) {
  try {
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
    return cache[barcode] ?? null;
  } catch {
    return null;
  }
}

export function setCachedProduct(barcode: string, product: any) {
  try {
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
    cache[barcode] = product;
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch (err) {
    console.debug("Offline cache failed", err);
  }
}
